module.exports = __webpack_public_path__ + "static/maps-7f84356646423a4f0730bd56c02733db.png";